/* Bilingual UI strings (formal Arabic first). Generated from the reference dashboard; keep keys stable. */
export const MESSAGES={
 title:{ar:'لوحة المؤشرات التنفيذية · استطلاعات الرأي',en:'Executive Insights Dashboard · Opinion Polls'},
 subtitle:{ar:'الإدارة العامة لاستطلاعات الرأي · وزارة البلديات والإسكان',en:'General Administration of Opinion Polls · Ministry of Municipalities and Housing'},
 go_home:{ ar:'الصفحة الرئيسية', en:'Home' },
 refresh_btn:{ ar:'تحديث البيانات', en:'Refresh data' },
 refreshing:{ ar:'جارٍ التحديث…', en:'Refreshing…' },
 refresh_ok:{ ar:'تم تحديث البيانات من قاعدة البيانات', en:'Data refreshed from the database' },
 refresh_err:{ ar:'تعذّر تحديث البيانات، يُرجى المحاولة لاحقاً', en:'Could not refresh the data, please try again later' },
 updated:{ar:'آخر تحديث للبيانات',en:'Data last refreshed'},
 s_geo:{ar:'الانتشار الجغرافي والمقارنة الإقليمية',en:'Geographic Reach & Regional Comparison'},
 s_geo_n:{ar:'توزيع النشاط ومؤشر الرضا على مناطق المملكة',en:"Activity and satisfaction across the Kingdom's regions"},
 c_map:{ar:'الخريطة الحرارية للمملكة',en:'Kingdom Heat Map'},
 c_map_h:{ar:'كثافة النشاط حسب المنطقة الإدارية',en:'Activity density by administrative region'},
 m_part:{ar:'المشاركة',en:'Participation'}, m_sat:{ar:'مؤشر الرضا',en:'Satisfaction'},
 c_rank:{ar:'ترتيب المناطق حسب مؤشر الرضا',en:'Regional Satisfaction Ranking'},
 c_rank_h:{ar:'أفضل المناطق أداءً والأقل أداءً',en:'Top and lowest performing regions'},
 s_sat:{ar:'مؤشر الرضا العام وتحليل الاتجاهات',en:'Overall Satisfaction & Trend Analysis'},
 s_sat_n:{ar:'مستخلص من ملايين الإجابات على مقاييس الرضا',en:'Derived from millions of satisfaction-scale responses'},
 c_sd:{ar:'توزيع مستويات الرضا',en:'Satisfaction Distribution'},
 sat_cap:{ar:'نسبة الإجابات الإيجابية',en:'share of positive responses'},
 c_ytrend:{ar:'تطور مؤشر الرضا سنوياً',en:'Satisfaction Index by Year'},
 c_ytrend_h:{ar:'النسبة المئوية للإجابات الإيجابية لكل عام',en:'Positive-response share per year'},
 c_trend:{ar:'حجم المشاركة عبر الزمن',en:'Participation Volume Over Time'},
 c_trend_h:{ar:'إجمالي المشاركين شهرياً',en:'Total participants per month'},
 c_demo:{ar:'التركيبة الديموغرافية',en:'Demographic Profile'},
 c_demo_h:{ar:'وفق إجابات المشاركين المصرّح بها',en:'Based on disclosed participant answers'},
 c_sector:{ar:'المشاركة حسب القطاع',en:'Participation by Sector'},
 s_ops:{ar:'أداء الخدمات ومستويات الإنجاز',en:'Service Performance & Delivery'},
 s_ops_n:{ar:'الطلبات الإجرائية واتفاقيات مستوى الخدمة',en:'Process requests and service-level agreements'},
 c_sla:{ar:'مراقبة مستوى الخدمة (SLA)',en:'SLA Monitoring'},
 c_sla_h:{ar:'أعمار الطلبات المفتوحة ومعدل الإنجاز',en:'Open-request ages and completion rate'},
 sla_rate:{ar:'معدل إنجاز الطلبات',en:'Request completion rate'},
 c_svc:{ar:'أداء الطلبات حسب نوع الإجراء',en:'Requests by Process Type'},
 c_svc_h:{ar:'مكتمل · قيد التنفيذ · مسودة',en:'Completed · In progress · Draft'},
 c_ai:{ar:'رؤى تحليلية',en:'Analytical Insights'},
 c_ai_h:{ar:'مؤشرات مستخلصة آلياً من البيانات',en:'Automatically derived from the data'},
 ai_b:{ar:'تحليل آلي',en:'AUTO'},
 c_lb:{ar:'أعلى الاستطلاعات مشاركةً',en:'Most Participated Surveys'},
 c_lb_h:{ar:'الاستطلاعات الأكثر استقطاباً للمشاركين',en:'Surveys attracting the most participants'},
 k_surveys:{ar:'إجمالي الاستطلاعات',en:'Total Surveys'},
 k_parts:{ar:'إجمالي المشاركين',en:'Total Participants'},
 k_resp:{ar:'الإجابات المُجمَّعة',en:'Responses Collected'},
 k_sat:{ar:'مؤشر الرضا العام',en:'Satisfaction Index'},
 k_appr:{ar:'استطلاعات معتمدة',en:'Approved Surveys'},
 k_time:{ar:'متوسط زمن الإكمال',en:'Avg. Completion Time'},
 q:{ar:'سؤال',en:'questions'}, minute:{ar:'دقيقة',en:'min'},
 of_t:{ar:'من أصل',en:'of'}, survey_u:{ar:'استطلاعاً',en:'surveys'},
 vs2023:{ar:'مقابل 2023',en:'vs 2023'},
 part_u:{ar:'مشارك',en:'participants'}, resp_u:{ar:'إجابة',en:'responses'}, rated_u:{ar:'إجابة مقيَّمة',en:'rated responses'},
 vsat:{ar:'راضٍ تماماً',en:'Very satisfied'}, sat:{ar:'راضٍ',en:'Satisfied'}, neu:{ar:'محايد',en:'Neutral'},
 dis:{ar:'غير راضٍ',en:'Dissatisfied'}, vdis:{ar:'غير راضٍ إطلاقاً',en:'Very dissatisfied'},
 positive:{ar:'إيجابي',en:'Positive'}, negative:{ar:'سلبي',en:'Negative'},
 male:{ar:'ذكور',en:'Male'}, female:{ar:'إناث',en:'Female'},
 saudi:{ar:'مواطنون',en:'Saudi'}, nonsaudi:{ar:'مقيمون',en:'Non-Saudi'},
 completed:{ar:'مكتمل',en:'Completed'}, inprogress:{ar:'قيد التنفيذ',en:'In progress'}, draft:{ar:'مسودة',en:'Draft'}, canceled:{ar:'ملغى',en:'Canceled'},
 open_req:{ar:'طلبات قيد التنفيذ',en:'Open requests'},
 avg_age:{ar:'متوسط عمر الطلب المفتوح',en:'Avg. open-request age'},
 max_age:{ar:'أقدم طلب مفتوح',en:'Oldest open request'},
 day_u:{ar:'يوماً',en:'days'},
 sat_hint:{ar:'إجمالي الإجابات المقيَّمة: ',en:'Total rated responses: '},
 low_sample:{ar:'عيّنة محدودة',en:'limited sample'},
 no_data:{ar:'لا تتوفر بيانات',en:'No data'},
 foot:{ar:'جميع المؤشرات محتسبة من بيانات المنصة الفعلية · تُحدَّث البيانات تلقائياً كل ساعة',
       en:'All indicators computed from actual platform data · Data refreshes automatically every hour'},
 geo_credit:{ar:'بيانات الحدود الإدارية: geoBoundaries (ODbL)',en:'Administrative boundaries: geoBoundaries (ODbL)'},
 nav_kpi:{ar:'المؤشرات الرئيسة',en:'Key Indicators'},
 nav_geo:{ar:'الانتشار الجغرافي',en:'Geography'},
 nav_sat:{ar:'الرضا والاتجاهات',en:'Satisfaction & Trends'},
 nav_ops:{ar:'الخدمات والإنجاز',en:'Services & Delivery'},
 yr_lbl:{ar:'عرض مؤشر الرضا حسب السنة:',en:'Satisfaction index by year:'},
 yr_all:{ar:'الكل',en:'All'},
 yr_scope:{ar:'يشمل الخريطة وترتيب المناطق · أحجام المشاركة إجمالية',en:'Applies to the map and regional ranking · participation volumes are all-time'},
 of5:{ar:'من 5',en:'/ 5'},
 yr_tag:{ar:'سنة',en:'Year'},
 data_scope:{ar:'نطاق البيانات',en:'Data coverage'},
 exp_btn:{ar:'تصدير ▾',en:'Export ▾'},
 exp_pdf:{ar:'طباعة / PDF',en:'Print / PDF'},
 exp_csv_r:{ar:'CSV — المناطق والسنوات',en:'CSV — Regions & Years'},
 exp_csv_s:{ar:'CSV — الاستطلاعات',en:'CSV — Surveys'},
 exp_json:{ar:'JSON — البيانات الكاملة',en:'JSON — Full snapshot'},
 qr_badge:{ar:'قراءة سريعة',en:'QUICK READ'},
 qr_title:{ar:'ما الذي يستحق الانتباه؟',en:'What deserves attention?'},
 qr_all:{ar:'استعراض جميع الرؤى ←',en:'View all insights →'},
 lb_search:{ar:'ابحث باسم الاستطلاع…',en:'Search surveys…'},
 lb_top:{ar:'أعلى 10 استطلاعات · اكتب للبحث في {n} استطلاعاً',en:'Top 10 · type to search all {n} surveys'},
 lb_found:{ar:'نتائج البحث: {m} من {n}',en:'Matches: {m} of {n}'},
 sig:{ar:'لوحة مؤشرات تنفيذية · منصة استطلاعات الرأي',en:'Executive Dashboard · Opinion Polls Platform'},
 nav_srv:{ar:'الاستطلاعات',en:'Surveys'},
 nav_home:{ar:'النظرة التنفيذية',en:'Executive View'},
 ex_satlbl:{ar:'مؤشر الرضا العام',en:'Overall Satisfaction Index'},
 ex_pts:{ar:'نقطة',en:'pts'},
 ex_vs:{ar:'مقابل',en:'vs'},
 ex_brief:{ar:'أبرز الخلاصات',en:'Key Takeaways'},
 ex_more:{ar:'التفاصيل ←',en:'Details →'},
 ex_rated:{ar:'محتسب من {n} إجابة على مقاييس الرضا',en:'Computed from {n} satisfaction-scale answers'},
 ex_kpi_p:{ar:'المشاركون في {y}',en:'Participants in {y}'},
 ex_kpi_p_ft:{ar:'الإجمالي التراكمي {n} مشارك',en:'All-time total {n} participants'},
 ex_resp_ft:{ar:'منذ {y0} عبر {n} استطلاعاً',en:'Since {y0} across {n} surveys'},
 ex_kpi_gap:{ar:'فجوة الرضا بين المناطق',en:'Regional Satisfaction Gap'},
 ex_gap_ft:{ar:'الأعلى: {top} · الأدنى: {low}',en:'Top: {top} · lowest: {low}'},
 ex_kpi_sla:{ar:'معدل إنجاز الطلبات',en:'Request Completion Rate'},
 ex_kpi_sla_ft:{ar:'{n} قيد التنفيذ · متوسط {d} يوماً',en:'{n} open · avg. {d} days'},
 ex_regions:{ar:'أعلى وأدنى المناطق في مؤشر الرضا',en:'Top & Lowest Regions by Satisfaction'},
 ex_regions_h:{ar:'ضمن المناطق ذات العينات الكافية · {y}',en:'Adequately sampled regions · {y}'},
 ex_othern:{ar:'… و{n} مناطق أخرى في العرض التفصيلي',en:'… and {n} more regions in the detailed view'},
 ex_cta:{ar:'استعراض التحليل التفصيلي الكامل ←',en:'Open the full analytical view →'},
 srv_title:{ar:'مستكشف الاستطلاعات',en:'Survey Explorer'},
 srv_hint:{ar:'انقر أي استطلاع لاستعراض نتائجه سؤالاً بسؤال',en:'Click any survey for question-by-question results'},
 srv_sort:{ar:'ترتيب حسب:',en:'Sort by:'},
 srt_part:{ar:'المشاركة',en:'Participation'},
 srt_sat:{ar:'مؤشر الرضا',en:'Satisfaction'},
 srt_name:{ar:'الاسم',en:'Name'},
 sec_all:{ar:'جميع القطاعات',en:'All sectors'},
 srv_count:{ar:'{m} من {n} استطلاعاً',en:'{m} of {n} surveys'},
 srv_qs:{ar:'سؤالاً',en:'questions'},
 srv_noresp:{ar:'دون إجابات مسجلة',en:'no recorded responses'},
 back_all:{ar:'→ جميع الاستطلاعات',en:'← All surveys'},
 d_parts:{ar:'المشاركون',en:'Participants'},
 d_answers:{ar:'الإجابات',en:'Answers'},
 d_qs:{ar:'الأسئلة',en:'Questions'},
 d_sat:{ar:'مؤشر الرضا',en:'Satisfaction'},
 d_score:{ar:'التقييم العام',en:'Overall score'},
 d_period:{ar:'فترة التنفيذ',en:'Active period'},
 d_partyr:{ar:'المشاركة حسب السنة',en:'Participation by year'},
 d_qres:{ar:'نتائج الأسئلة',en:'Question results'},
 d_qsearch:{ar:'ابحث في نص الأسئلة…',en:'Search question text…'},
 d_qshow:{ar:'عرض {m} من {n} سؤالاً',en:'Showing {m} of {n} questions'},
 d_yrfilter:{ar:'عرض النتائج حسب السنة:',en:'Results by year:'},
 d_txt:{ar:'إجابة نصية / حرة',en:'free-text answers'},
 d_del:{ar:'سؤال محذوف',en:'deleted question'},
 d_loading:{ar:'جارٍ تحميل بيانات الاستطلاع…',en:'Loading survey data…'},
 d_missing:{ar:'تفاصيل هذا الاستطلاع غير متوفرة حالياً.',en:'Details for this survey are not available.'},
 d_ans_u:{ar:'إجابة',en:'answers'},
 d_ratedhint:{ar:'محتسب من {n} إجابة على مقاييس الرضا ضمن هذا الاستطلاع',en:'computed from {n} satisfaction-scale answers in this survey'},
 exp_csv_q:{ar:'CSV — نتائج هذا الاستطلاع',en:"CSV — this survey's results"},
 qt1:{ar:'إجابة قصيرة',en:'Short answer'}, qt2:{ar:'اختيار من متعدد',en:'Multiple choice'},
 qt3:{ar:'مربعات اختيار',en:'Checkboxes'}, qt4:{ar:'قائمة منسدلة',en:'Dropdown'},
 qt5:{ar:'تقييم',en:'Rating'}, qt6:{ar:'رقم',en:'Number'}, qt7:{ar:'نعم / لا',en:'Yes / No'},
 qt8:{ar:'تاريخ',en:'Date'}, qt9:{ar:'نص طويل',en:'Text area'}, qt10:{ar:'مصفوفة ثنائية',en:'Bipolar matrix'},
 qt11:{ar:'قائمة معرّفة',en:'Predefined dropdown'}, qt12:{ar:'صورة',en:'Image'}, qt13:{ar:'رابط فيديو',en:'Video link'},
 qt14:{ar:'NPS',en:'NPS'}, qt15:{ar:'خريطة',en:'Map'}, qt16:{ar:'عنوان',en:'Label'},
 qt17:{ar:'تاريخ هجري',en:'Hijri date'}, qt18:{ar:'رقم جوال',en:'Phone'}, qt19:{ar:'بريد إلكتروني',en:'Email'},
 qt20:{ar:'اختيار مصوّر',en:'Picture choice'}, qt21:{ar:'نموذج تواصل',en:'Contact form'}, qt22:{ar:'رابط',en:'URL'},
 qt23:{ar:'رفع ملفات',en:'File upload'}, qt24:{ar:'موافقة',en:'Consent'}, qt25:{ar:'ترتيب',en:'Ranking'},
 qt26:{ar:'محرر نصوص',en:'Text editor'}, qt27:{ar:'سؤال تحقق',en:'Tricky question'}, qt28:{ar:'CSAT-5',en:'CSAT-5'},
 qt29:{ar:'CSAT-3',en:'CSAT-3'},
 /* strategic view */
 nav_str:{ar:'المؤشرات الاستراتيجية',en:'Strategic Indicators'},
 st_title:{ar:'المؤشرات الاستراتيجية',en:'Strategic Indicators'},
 st_note:{ar:'مساران استراتيجيان: المنتجات الإسكانية والخدمات البلدية · مصدر مؤقت: ملفات البيانات الخام حتى ربطها بالمنصة',en:'Two strategic tracks: housing products and municipal services · interim source: raw data files until loaded into the platform'},
 st_k_house:{ar:'رضا المستفيدين عن المنتجات السكنية',en:'Beneficiary satisfaction — housing products'},
 st_k_house_ft:{ar:'{n} مستفيداً · {a}–{b}',en:'{n} beneficiaries · {a}–{b}'},
 st_k_muni:{ar:'مؤشر رضا المواطنين عن الخدمات البلدية',en:'Citizen satisfaction index — municipal services'},
 st_k_muni_ft:{ar:'14 خدمة · {n} مواطناً · {y}',en:'14 services · {n} citizens · {y}'},
 st_k_prio:{ar:'أولوية التدخل الأولى',en:'Top intervention priority'},
 st_k_prio_ft:{ar:'{p} غير راضين · محور {ax}',en:'{p} dissatisfied · {ax} axis'},
 st_k_gap:{ar:'فجوة الأمانات في الخدمات البلدية',en:'Municipal-services gap across amanahs'},
 st_gap_ft:{ar:'الأعلى: {top} · الأدنى: {low}',en:'Top: {top} · Lowest: {low}'},
 st_vs:{ar:'مقابل',en:'vs'},
 st_c_prio:{ar:'خريطة أولويات الخدمات البلدية',en:'Municipal services priority map'},
 st_c_prio_h:{ar:'الخدمات الأربع عشرة مرتّبة من الأدنى رضاً إلى الأعلى · {a}–{b}',en:'All 14 services ranked from lowest to highest satisfaction · {a}–{b}'},
 st_c_aman:{ar:'الأمانات حسب مؤشر الخدمات البلدية',en:'Amanahs by municipal-services index'},
 st_c_aman_h:{ar:'متوسط الرضا عبر الخدمات الأربع عشرة · {a}–{b}',en:'Average satisfaction across the 14 services · {a}–{b}'},
 st_c_axes:{ar:'محاور الخدمات البلدية عبر السنوات',en:'Municipal service axes by year'},
 st_c_axes_h:{ar:'نسبة الرضا لكل محور',en:'Satisfaction share per axis'},
 st_c_prod:{ar:'الرضا حسب المنتج السكني',en:'Satisfaction by housing product'},
 st_c_prod_h:{ar:'نسبة الراضين عن المنتج الذي حصلوا عليه',en:'Share satisfied with the product obtained'},
 st_c_htrend:{ar:'تطور رضا المستفيدين عن المنتجات السكنية',en:'Housing-product satisfaction over time'},
 st_c_htrend_h:{ar:'نسبة الراضين سنوياً',en:'Share satisfied per year'},
 st_c_journey:{ar:'محرّكات عدم الرضا في رحلة الحصول على المنتج السكني',en:'Drivers of dissatisfaction in the housing journey'},
 st_c_journey_h:{ar:'أُجيب عنها من المستفيدين غير الراضين أو المحايدين فقط ({n} مستفيداً · {p} من العينة)',en:'Answered only by dissatisfied or neutral beneficiaries ({n} · {p} of sample)'},
 st_c_ins:{ar:'رؤى استراتيجية وتوصيات',en:'Strategic insights & recommendations'},
 st_c_ins_h:{ar:'مستخلصة آلياً من المسارين',en:'Auto-derived from both tracks'},
 st_contact:{ar:'تجربة التواصل مع الوزارة',en:'Contact experience with the Ministry'},
 st_contacted:{ar:'تواصلوا مع الوزارة',en:'contacted the Ministry'},
 st_complaints:{ar:'من التواصلات شكاوى',en:'of contacts were complaints'},
 st_csat:{ar:'راضون عن التواصل',en:'satisfied with the contact'},
 st_csat_cmp:{ar:'رضا أصحاب الشكاوى',en:'complainants satisfied'},
 st_axis:{ar:'محور',en:'axis'},
 st_d24:{ar:'مقابل 2024',en:'vs 2024'},
 st_resp:{ar:'مستجيباً',en:'respondents'},
 st_benef:{ar:'مستفيداً',en:'beneficiaries'},
 st_share:{ar:'من العينة',en:'of sample'},
 st_src:{ar:'المصدر',en:'Source'},
 ex_strat:{ar:'المسارات الاستراتيجية',en:'Strategic tracks'},
 ex_strat_more:{ar:'استعراض المؤشرات الاستراتيجية ←',en:'Open strategic indicators →'},
 st_missing:{ar:'ملف strategic.js غير موجود — يُرجى تشغيل tools/build-strategic.py.',en:'strategic.js is missing — run tools/build-strategic.py.'}, qt30:{ar:'مربعات دقيقة',en:'Precise checkboxes'}, qt31:{ar:'إجابات مرتبة',en:'Ordered answers'},
 nav_cmp:{ar:'المقارنات',en:'Comparisons'},
 cmp_title:{ar:'المقارنات الديناميكية',en:'Dynamic Comparisons'},
 cmp_note:{ar:'اختر بُعد المقارنة ثم العناصر — تُحدَّث النتائج فوراً ويمكن مشاركة الرابط',en:'Pick a dimension, then the items — results update instantly and the link is shareable'},
 cmp_dim:{ar:'ماذا تريد أن تقارن؟',en:'What do you want to compare?'},
 cmp_d_surveys:{ar:'استطلاعات',en:'Surveys'}, cmp_d_years:{ar:'سنوات',en:'Years'}, cmp_d_sectors:{ar:'قطاعات',en:'Sectors'}, cmp_d_regions:{ar:'مناطق',en:'Regions'},
 cmp_pick_srv:{ar:'ابحث عن استطلاع وانقر لإضافته…',en:'Search for a survey and click to add it…'},
 cmp_subject:{ar:'موضوع المقارنة',en:'Subject'},
 cmp_all_platform:{ar:'المنصة كاملة (جميع الاستطلاعات)',en:'Whole platform (all surveys)'},
 cmp_pick_years:{ar:'السنوات',en:'Years'},
 cmp_year:{ar:'الفترة',en:'Period'},
 cmp_year_h:{ar:'يُطبَّق على جميع العناصر لضمان عدالة المقارنة',en:'Applied to every item so the comparison stays fair'},
 cmp_max:{ar:'الحد الأقصى {n} عناصر',en:'Max {n} items'},
 cmp_presets:{ar:'مقارنات جاهزة:',en:'Quick presets:'},
 cmp_p_sec:{ar:'القطاعات الثلاثة',en:'Three sectors'},
 cmp_p_yr:{ar:'آخر سنتين للمنصة',en:'Platform, last 2 years'},
 cmp_p_reg:{ar:'أعلى وأدنى منطقة',en:'Top vs bottom region'},
 cmp_p_srv:{ar:'أكبر استطلاعين',en:'Two largest surveys'},
 cmp_need:{ar:'اختر عنصرين على الأقل لبدء المقارنة',en:'Pick at least two items to compare'},
 cmp_loading:{ar:'جارٍ تحميل بيانات الاستطلاعات…',en:'Loading survey data…'},
 cmp_verdict:{ar:'الخلاصة',en:'Verdict'},
 cmp_noverdict:{ar:'لا يمكن إصدار خلاصة — عنصر واحد على الأقل بلا بيانات رضا كافية.',en:'No verdict possible — at least one item lacks sufficient satisfaction data.'},
 cmp_gap_cap:{ar:'نقطة فارق في مؤشر الرضا',en:'pts satisfaction gap'},
 cmp_scope:{ar:'النطاق',en:'Scope'},
 cmp_items:{ar:'عناصر',en:'items'},
 cmp_table:{ar:'بطاقة المقارنة',en:'Comparison card'},
 cmp_table_h:{ar:'الأفضل في كل مؤشر مظلل بالأخضر والأدنى بالكهرماني — العينات الصغيرة مستثناة من الترتيب',en:'Best per metric in green, lowest in amber — small samples are excluded from ranking'},
 cmp_diff:{ar:'الفارق',en:'Gap'},
 cmp_small:{ar:'عينة صغيرة',en:'Small sample'},
 cmp_best:{ar:'الأعلى',en:'Best'}, cmp_worst:{ar:'الأدنى',en:'Lowest'},
 cmp_r_parts:{ar:'المشاركون',en:'Participants'}, cmp_r_ans:{ar:'الإجابات',en:'Answers'}, cmp_r_rated:{ar:'الإجابات المقيَّمة',en:'Rated answers'},
 cmp_r_sat:{ar:'مؤشر الرضا',en:'Satisfaction'}, cmp_r_score:{ar:'التقييم (من 5)',en:'Score (of 5)'},
 cmp_r_pos:{ar:'إيجابي',en:'Positive'}, cmp_r_neu:{ar:'محايد',en:'Neutral'}, cmp_r_neg:{ar:'سلبي',en:'Negative'},
 cmp_r_qs:{ar:'عدد الأسئلة',en:'Questions'}, cmp_r_srvs:{ar:'عدد الاستطلاعات',en:'Surveys'}, cmp_r_period:{ar:'الفترة',en:'Period'},
 cmp_dist:{ar:'توزيع مستويات الرضا',en:'Satisfaction distribution'},
 cmp_dist_h:{ar:'على المقياس نفسه لتسهيل المقارنة البصرية',en:'Same scale for direct visual comparison'},
 cmp_trend:{ar:'تطور مؤشر الرضا سنوياً',en:'Satisfaction by year'},
 cmp_trend_h:{ar:'جميع السنوات المتاحة بغض النظر عن فلتر الفترة',en:'All available years, regardless of the period filter'},
 cmp_part:{ar:'المشاركة سنوياً',en:'Participation by year'},
 cmp_part_h:{ar:'عدد المشاركين لكل عنصر وسنة',en:'Participants per item and year'},
 cmp_ins:{ar:'رؤى المقارنة',en:'Comparison insights'},
 cmp_ins_h:{ar:'مستخلصة آلياً من العناصر المحددة',en:'Generated automatically from the selected items'},
 cmp_qs:{ar:'مقارنة الأسئلة المشتركة',en:'Shared questions'},
 cmp_qs_h:{ar:'{n} سؤالاً بنص مطابق لدى جميع العناصر — النسبة من إجابات كل عنصر',en:"{n} questions with identical wording across all items — share of each item's answers"},
 cmp_qs_more:{ar:'عرض {n} أسئلة مشتركة أخرى',en:'Show {n} more shared questions'},
 cmp_qs_less:{ar:'عرض أقل',en:'Show fewer'},
 cmp_csv:{ar:'CSV — المقارنة',en:'CSV — comparison'},
 cmp_pts:{ar:'نقطة',en:'pts'},
 cmp_sel:{ar:'العناصر:',en:'Items:'},
 cmp_no_sat:{ar:'لا تتضمن أسئلة رضا',en:'no satisfaction questions'},
 cmp_d_cities:{ar:'مدن وأمانات',en:'Cities'},
 cmp_cities_opt:{ar:'تقسيم حسب المدينة (اختياري):',en:'Split by city (optional):'},
 cmp_nosplit:{ar:'بدون تقسيم',en:'No split'},
 cmp_combo_max:{ar:'حتى {n} أعمدة (استطلاعات × مدن)',en:'Up to {n} columns (surveys × cities)'},
 cmp_cov:{ar:'الموقع معروف لـ {p}% من المشاركين',en:'location known for {p}% of participants'},
 cmp_city_note:{ar:'أرقام المدن تشمل المشاركين محدّدي الموقع جغرافياً فقط',en:'City figures cover geo-located participants only'},
 cmp_noreg:{ar:'بيانات المدن لكل استطلاع غير متوفرة حالياً.',en:'Per-survey city data is not available.'},
 cmp_p_city:{ar:'أكبر استطلاع × أكبر 3 مدن',en:'Largest survey × top 3 cities'},
 cmp_loc:{ar:'الموقع معروف',en:'located'},
 cmp_nocity:{ar:'لا مشاركين محدّدي الموقع في هذه المدينة',en:'no geo-located participants in this city'},
 cmp_loc_only:{ar:'تظهر الاستطلاعات التي تتوفر لها بيانات مواقع المشاركين فقط ({n} استطلاعاً)',en:'Only surveys with participant location data are listed ({n} surveys)'},
 nav_ind:{ar:'العرض التحليلي',en:'Analytical view'},
 loading:{ar:'جارٍ تحميل البيانات…',en:'Loading data…'},
 load_err:{ar:'تعذّر تحميل البيانات من الخادم.',en:'Could not load data from the server.'},
 retry:{ar:'إعادة المحاولة',en:'Retry'},
 theme_dark:{ar:'الوضع الداكن',en:'Dark mode'}, theme_light:{ar:'الوضع الفاتح',en:'Light mode'},
 lang_switch:{ar:'English',en:'عربي'},
 m_low:{ar:'منخفضة',en:'low'}, m_high:{ar:'مرتفعة',en:'high'},
}

export function translate(lang,key,vars){
  const e=MESSAGES[key];let s=e?(e[lang]||e.ar):key
  if(vars)for(const k in vars)s=s.split('{'+k+'}').join(String(vars[k]))
  return s
}
